import axios from 'axios';
import router from '../router';

let instance = null;

const API_URL = process.env.VUE_APP_BFF_URL;

class BaseHttp {
  constructor () {
    this.requestLib = axios.create({
      baseURL: API_URL,
    },);
  }

  setAccessToken = (accessToken,) => {
    this.requestLib.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  };

  setFranchise = (franchise,) => {
    this.requestLib.defaults.headers.common.franchise = franchise;
  };

  unsetFranchise = () => {
    delete this.requestLib.defaults.headers.common.franchise;
  };

  get = (...params) => {
    return this.requestLib.get(...params,);
  };

  post = (...params) => {
    return this.requestLib.post(...params,);
  };

  delete = (...params) => {
    return this.requestLib.delete(...params,);
  };

  put = (...params) => {
    return this.requestLib.put(...params,);
  };

  patch = (...params) => {
    return this.requestLib.patch(...params,);
  };

  install (Vue,) {
    //Install for VueJS Plugin
    console.log('[BASE_HTTP] Install',);

    Vue.prototype.$http = {
      get: this.get,
      post: this.post,
      delete: this.delete,
      put: this.put,
      patch: this.patch,
      unsetFranchise: this.unsetFranchise,
    };
  }

  handleError = (error, redirect = true,) => {
    const message = {
      code: 0,
      text: 'Erro de rede',
      icon: '',
    };
    if (error) {
      if (Object.prototype.hasOwnProperty.call(error, 'message',)) {
        message.text = error.message;
      }
      if (error.response) {
        message.code = error.response.status;
        message.text = {
          400: 'A requisição não pôde ser processada pelo servidor :(',
          // 401: 'Você não possui autorização para utilizar o sistema',
          403: 'Parece que você não tem permissão para acessar essa página :(',
          404: 'Esta página não foi encontrada :(',
          // 405: 'Recurso solicitado foi desativado ou não pode ser utilizado',
          500: 'Ocorreu um erro no servidor :(',
        }[error.response.status];
        message.icon = {
          400: require('@/assets/img-notfound.svg',),
          // 401: 'path/to/icon',
          403: require('@/assets/img-notallowed.svg',),
          404: require('@/assets/img-notfound.svg',),
          // 405: 'path/to/icon',
          500: require('@/assets/img-notfound.svg',),
        }[error.response.status];
      }
      if (
        Object.prototype.hasOwnProperty.call(error, 'response',) &&
        Object.prototype.hasOwnProperty.call(error.response, 'data',)
      ) {
        if (
          Object.prototype.hasOwnProperty.call(error.response.data, 'message',) &&
          error.response.data.message.length > 0
        ) {
          message.text = error.response.data.message;
        }
      }
      if(redirect) {
        return router.push({
          name: 'request-error',
          params: { message, },
        },);
      }

      return Promise.reject(message,);
    }
  };

  getAPIURL = () => API_URL;
}

export default (() => {
  if (!instance) {instance = new BaseHttp();}

  return instance;
})();
